// UserStore.js

import { makeAutoObservable } from 'mobx'
import { userHomePaths } from '../router/routes'

export default class UserStore {

    constructor() {
        const savedUser = JSON.parse(localStorage.getItem('user'));
        this._user = savedUser || null;
        this._isAuth = !!savedUser;
        makeAutoObservable(this);
    }

    getValidUser() {
        try {
            const storedUser = JSON.parse(localStorage.getItem('user'));
            if (!storedUser || typeof storedUser !== 'object') throw new Error("Данные пользователя отсутствуют или повреждены");

            // 🔥 Проверяем, есть ли нужные поля
            if (!storedUser.id || !storedUser.email || !storedUser.role) {
                throw new Error("Недостаточно данных в объекте пользователя");
            }

            if (this._user.role === 'anonymous' && storedUser.teacher_courses) {
                throw new Error("Для преподавателя недоступно получение списка курсов");
            }

            return storedUser;
        } catch (error) {
            console.warn("Ошибка загрузки пользователя из localStorage:", error.message);
            localStorage.removeItem('user'); // ✅ Очищаем невалидные данные
            return null;
        }
    }

    setIsAuth(bool) {
        this._isAuth = bool
    }

    setUser(user) {
        this._user = user;
        this._isAuth = !!user;
        localStorage.setItem('user', JSON.stringify(user)); // ✅ Теперь сохраняем сразу
    }


    setDisplayProfileFill(bool) {
        this._displayProfileFill = bool
    }

    clearUserData() {
        console.log("🧹 Очищаем данные пользователя...");
        this._user = null;
        this._isAuth = false;
    }



    get isAuth() {
        return this._isAuth
    }

    get user() {
        return this._user
    }

    get role() {
        return this._user ? this._user.role : 'anonymous'
    }

    get purchased_courses() {
        return Array.isArray(this._user?.purchased_courses) ? this._user.purchased_courses : [];
    }


    get userHomePath() {
        return userHomePaths[this.role]
    }

    get needsProfileUpdate() {
        return !(this._user.email && this._user.email.length)
    }

    get displayProfileFill() {
        return this._displayProfileFill
    }
}

